import { render } from "./DialogWrapper.vue?vue&type=template&id=e31d563a&ts=true"
import script from "./DialogWrapper.vue?vue&type=script&lang=ts"
export * from "./DialogWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__